import MainMenu from '@/components/foundation/main-menu/MainMenu'
import SuppliersListing from '@/view/record/suppliers/suppliers-listing/SuppliersListing'
import SuppliersEditor from '@/view/record/suppliers/suppliers-editor/SuppliersEditor'

export const SuppliersListingRoute = {
  path: '/suppliers',
  name: 'Suppliers',
  components: {
    default: SuppliersListing,
    mainMenu: MainMenu
  },
  props: (route) => {
    return {
      query: route.query.s
    }
  },
  meta: {
    mainArea: 'suppliers',
    area: 'suppliers',
    breadcrumb: [
      { name: 'Fornecedores' }
    ]
  }
}

export const SuppliersEditorRoute = {
  path: '/suppliers/:supplierId',
  name: 'SuppliersEditor',
  components: {
    default: SuppliersEditor,
    mainMenu: MainMenu
  },
  meta: {
    mainArea: 'suppliers',
    area: 'suppliers',
    breadcrumb: [
      { name: 'Fornecedores', link: '/suppliers' },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION'
      },
      {
        name: 'Edição'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/SuppliersRoute.js